import FormMake from './form-make.js'
import FormTechnicalMake, {FormTechnicalMakeBasicContent} from './form-technical-make.js'

/**
 * FormMake gets makes from automotive (used in motos)
 */
export default FormMake

/**
 * FormTechnicalMake gets makes from vehicle specs micro
 */
export {FormTechnicalMake, FormTechnicalMakeBasicContent}
